import { useState } from "react";
import classes from "./styles.module.scss";
import { InputField } from '../../components/InputField';
import { MainButton } from '../../components/MainButton';
import Textarea from '../../components/Textarea';
import { showNotification } from "../../store/features/notifications/notificationSlice";
import { useAppDispatch } from "../../store/hooks";

export const ContactPage = () => {
  const dispatch = useAppDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the contact form data to your backend
    // For now, we'll just show a success notification
    dispatch(showNotification({ message: "Thank you for your message! We'll get back to you soon.", type: "success" }));
    // Reset form
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className={classes.ContactPage}>
      <div className={classes.contentWrapper}>
        {/* <div className={classes.logo} onClick={() => navigate("/")}>.shortform</div> */}
        <div className={classes.infoWrapper}>
          <h2>Contact Us</h2>
          <div className={classes.infoText}>
            <p>Have a question, suggestion, or need support? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
          </div>
        </div>
        <div className={classes.formWrapper}>
          <InputField label='Name' value={name} onChange={(e) => setName(e.target.value)} />
          <InputField label='Email' role='email' value={email} onChange={(e) => setEmail(e.target.value)} />
          <Textarea label='Message' value={message} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value)} placeholder="Tell us how we can help..." />
          <MainButton title='Send Message' variant='primary' fullWidth onClick={handleSubmit} disabled={!name || !email || !message} />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
